import { GUEST_PUZZLE_COINS_KEY } from "./constants";

export function loadGuestPuzzleCoins() {
    try {
        const n = Number(localStorage.getItem(GUEST_PUZZLE_COINS_KEY));
        return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
    } catch {
        return 0;
    }
}

export function saveGuestPuzzleCoins(amount) {
    const n = Math.max(0, Math.floor(Number(amount) || 0));
    try {
        localStorage.setItem(GUEST_PUZZLE_COINS_KEY, String(n));
    } catch {
        /* ignore quota */
    }
    return n;
}

export function addGuestPuzzleCoins(delta) {
    const gift = Math.max(0, Math.floor(Number(delta) || 0));
    return saveGuestPuzzleCoins(loadGuestPuzzleCoins() + gift);
}
